import { inject, Injectable } from '@angular/core';
import { openCiSnackbar } from '@iurban-malaga/cicerone-ui';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class Snackbar {
  private _translationService = inject(TranslationService);

  public showSuccessSnackbar(message: string, duration?: number, containerElement?: HTMLElement) {
    openCiSnackbar({
      content: this._translationService.instant(message),
      status: 'success',
      'icon-name': 'btn-check',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      'container-element': containerElement ?? document.querySelector('ion-app') as HTMLElement,
      duration: duration ?? 4000
    });
  }

  public showErrorSnackbar(message: string, duration?: number, containerElement?: HTMLElement) {
    openCiSnackbar({
      content: this._translationService.instant(message),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      'container-element': containerElement ?? document.querySelector('ion-app') as HTMLElement,
      duration: duration ?? 4000
    });

    // TODO: DEBUG LATER
    //this._showDebugOverlay();
  }

  private _showDebugOverlay(): void {
    setTimeout(() => {
      const existing = document.getElementById('snackbar-debug-overlay');
      if (existing) existing.remove();

      const container = document.querySelector('ci-snackbar-container');
      const snackbar = document.querySelector('ci-snackbar');
      const lines: string[] = [];

      lines.push(`container in DOM: ${!!container}`);
      lines.push(`container parent: ${container?.parentElement?.tagName ?? 'N/A'}`);
      lines.push(`snackbar in DOM: ${!!snackbar}`);

      if (container) {
        const shadow = (container as HTMLElement & { shadowRoot: ShadowRoot }).shadowRoot;
        const innerDiv = shadow?.querySelector('.snackbar-container') as HTMLElement | null;
        if (innerDiv) {
          const cs = getComputedStyle(innerDiv);
          lines.push(`inner display: ${cs.display}`);
          lines.push(`inner visibility: ${cs.visibility}`);
          lines.push(`inner opacity: ${cs.opacity}`);
          lines.push(`inner position: ${cs.position}`);
          lines.push(`inner bottom: ${cs.bottom}`);
          lines.push(`inner height: ${cs.height}`);
          lines.push(`inner width: ${cs.width}`);
          lines.push(`inner zIndex: ${cs.zIndex}`);
          lines.push(`inner overflow: ${cs.overflow}`);
        } else {
          lines.push('inner div: NOT FOUND');
        }
      }

      if (snackbar) {
        const cs = getComputedStyle(snackbar);
        lines.push(`sb display: ${cs.display}`);
        lines.push(`sb visibility: ${cs.visibility}`);
        lines.push(`sb opacity: ${cs.opacity}`);
        lines.push(`sb height: ${cs.height}`);
        lines.push(`sb width: ${cs.width}`);
      }

      const overlay = document.createElement('div');
      overlay.id = 'snackbar-debug-overlay';
      overlay.style.cssText = 'position:fixed;top:10px;left:10px;right:10px;z-index:99999999999;background:#1a1a1a;color:#0f0;font:12px/1.6 monospace;padding:12px;border:2px solid red;border-radius:8px;max-height:60vh;overflow:auto;white-space:pre-wrap;';
      overlay.textContent = lines.join('\n');
      overlay.addEventListener('click', () => overlay.remove());
      document.body.appendChild(overlay);
    }, 500);
  }
}
